import VisualSearchResultState, { initialState } from './State';
import {
  TOGGLE_VISUALSEARCH_GRAYSCALE,
  VISUALSEARCH_SET_CROP_IMAGE,
  VISUALSEARCH_SET_IMAGE,
  VISUALSEARCH_SET_LUMINANCE,
  VisualSearchResultAction
} from './Actions';

function visualSearchResultReducer(state = initialState, action: VisualSearchResultAction): VisualSearchResultState {
  switch (action.type) {
    case TOGGLE_VISUALSEARCH_GRAYSCALE:
      return {
        ...state,
        enableGrayScale: action.enableGrayScale
      };
    case VISUALSEARCH_SET_IMAGE:
      return {
        ...state,
        imageLoaded: action.imageLoaded,
        imageSrc: action.imageSrc,
        imageData: action.imageData,
        useCropSearch: action.useCropSearch,
        cropImageSrc: action.cropImageSrc,
        cropImageData: action.cropImageData,
      };
    case VISUALSEARCH_SET_LUMINANCE:
      return {
        ...state,
        luminanceSearch: action.luminanceSearch
      };
    case VISUALSEARCH_SET_CROP_IMAGE:
      return {
        ...state,
        useCropSearch: action.useCropSearch,
        cropImageSrc: action.cropImageSrc,
        cropImageData: action.cropImageData,
      };
    default:
      return state;
  }
}

export default visualSearchResultReducer;
